/* istanbul ignore file */
import { CreateButton } from 'framework/ui/ui-builder';
import { useEmployeeAssignmentUrl } from 'domain/people/employee/assignments/assignmentRouting';
import { CREATE_ASSIGNMENT } from 'domain/shared/assignment';

const CreateEmployeeAssignmentButton = () => {
  const { getCreateUrl } = useEmployeeAssignmentUrl();

  return (
    <CreateButton
      label="Create assignment"
      size="small"
      variant="contained"
      url={getCreateUrl()}
      permissionToCheck={CREATE_ASSIGNMENT}
    />
  );
};

export default CreateEmployeeAssignmentButton;
